module.exports = __webpack_public_path__ + "static/img/W.4d17a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hunter/W.png
// module id = cXgp
// module chunks = 0